























import {groupBy} from "@/edinet/libs/utils";

import {DocIndex, DocType} from "@/edinet/types"
import {PropType} from "@vue/composition-api"
import dayjs from "dayjs";
import Vue from 'vue'

export default Vue.extend({
  props: {
    allIndices: Array as PropType<Array<DocIndex>>,
    currentIndex: Object as PropType<DocIndex>,
    hasNext: Boolean,
    loading: Boolean,
    showAll: Boolean,
    handleKeyboard: {
      type: Boolean,
      default: false
    },
    isMain: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      FinancialsDocType: DocType.Financials,
      focusIndexId: (this.handleKeyboard) ? this.currentIndex.id : ''
    }
  },
  mounted() {
    if (this.handleKeyboard) {
      document.addEventListener('keydown', this.moveCursor)
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.moveCursor)
  },
  computed: {
    displayIndices: function(): DocIndex[] {
      if (!this.showAll) {
        return this.allIndices.filter(x => x.type === DocType.Financials)
      } else {
        return this.allIndices
      }
    },
    groupedIndices(): Array<[number, DocIndex[]]> {
      const g = groupBy(this.displayIndices, x => dayjs(x.meta.datePublish).year())
      const l = Array.from(g.entries()).sort((x, y) => y[0] - x[0])
      return l
    }
  },
  methods: {
    moveCursor(e: KeyboardEvent) {
      if (this.isMain) {
        // console.log(e)
        if (e.key === 'ArrowUp') {
          const i = this.displayIndices.findIndex(x => x.id === this.focusIndexId)
          if (i > 0) {
            this.focusIndexId = this.displayIndices[i - 1].id
          }
        } else if (e.key === 'ArrowDown') {
          const i = this.displayIndices.findIndex(x => x.id === this.focusIndexId)
          if (i < this.displayIndices.length - 1) {
            this.focusIndexId = this.displayIndices[i + 1].id
          }
        } else if (e.key === 'Enter') {
          const index = this.displayIndices.find(x => x.id === this.focusIndexId)
          if (index) {
            this.$emit('selectIndex', index)
          }
        }
      }

    }
  },
  filters: {
    monthDay: function(date: Date) {
      return dayjs(date).format('MM/DD')
    }
  },
  watch: {
    allIndices() {
      if (this.handleKeyboard === true && this.displayIndices.length > 0) {
        this.focusIndexId = this.displayIndices[0].id
      }
    }
  }
})
